import { getCheckout, State as CheckoutState } from "./checkout";
import { BusinessProduct } from "../../../../../models/state";

export type State = CheckoutState;
export const getBusinessProducts: (state: State) => Partial<BusinessProduct> = (state) =>
    getCheckout(state).businessProduct || {};
export const isMbb: (state: State) => boolean = (state) => getCheckout(state).isMbb || false;
